import type { SyncEndpoint as SyncWorkflowsEndpoint } from '../../../server/http/workflows/sync.no-deps'
import { Serv_send } from './Serv.socketClient'
import type { Sync_Params } from '../Sync/Sync.standardSync'
import type { SyncActivityWorkflowOutput } from '../../../shared/domain/workflows/types.no-deps'

export type { SyncWorkflowsEndpoint }

export async function Serv_syncActivityWorkflows(params: Sync_Params) {
    const lastSyncTime = params.lastSyncTime.toISOString()
    const response = (await Serv_send('workflows.sync', {
        lastSyncTime,
    })) as SyncActivityWorkflowOutput

    // Pass back teams unchanged even though endpoint doesn't currently use it just
    // so we have a consistent API with other sync endpoints
    const teams = params.teams

    return { ...response, syncTime: new Date(response.syncTime), teams }
}
